import barba from '@barba/core';
import aos from './utils/aos'

// Site-wide Components
import slideshow from './components/slideshow'
import contentSlideshow from './components/content-slideshow'
import video from './components/video'

// init current page
window.current_page = null

barba.hooks.beforeEnter(({ next }) => {
	window.scrollTo(0,0)
	aos(next.container)
	slideshow(next)
	contentSlideshow(next)
	video(next.container)
	window.current_page = next.namespace // update current page
})

barba.hooks.afterEnter(({ next }) => {
	// after enter hook stuff
})

barba.hooks.beforeLeave(({ next }) => {
	// bedfore leave hook stuff
})

barba.hooks.leave(({ next }) => {
	
})


// import all transitions in the barba transitions folder
const transitions = []
const t = require.context('./transitions/', false, /\.js$/)
t.keys().forEach(key => transitions.push(t(key).default))

// import all views in the barba views folder
const views = []
const v = require.context('./views/', false, /\.js$/)
v.keys().forEach(key => views.push(v(key).default))

// initialise Barba.js
barba.init({
	transitions,
	views,
	timeout: 5000,
	debug: true
})
